'use strict';

$(document).ready(function(){
    //Обрезаем лишний текст
    clampText();

    //Открытие popup по клику на button
    $(document).on('click', 'button[data-popup-name]', function () {
        showModalWindow($(this));
    })
    // $('button[data-popup-name]').on('click', function () {
    //
    //     showModalWindow($(this));
    //
    // });

    //Открытие popup по клику на карточку
    $('a[data-popup-name]').on('click', function () {

        showModalWindow($(this));

    });

    // //Открытие popup по хэшу
    // if (window.location.hash === '#volgograd') {
    //     $('.tabs__name:last-child').click();
    // }
});

function schoolDataSet(form) {
    'use strict'

    const googleCaptcha = form.find('.google-recaptcha')

    grecaptcha.ready(function() {
        grecaptcha.execute('6LegL8QcAAAAADO1TgGfQmdIepdvxi1pzP-JQa4D', {action: 'submit'}).then(function(token) {

            googleCaptcha.val(token)

            getDataFromAjax(form.attr('action'), 'POST', new FormData(form[0]))
                .then(res => {
                    // hidePreloader();
                    schoolDataAnswer(form, res);
                })
        });
    });
}

function schoolDataAnswer(form, res) {
    'use strict'
    const successfulBlock = form.parents('.popup').find('.popup__successful')
    const errorBlock = form.parents('.popup').find('.popup__error')

    if (res === 'successful') {
        form.addClass('form--hidden')
        successfulBlock.addClass('popup__successful--active')
    } else {
        form.addClass('form--hidden')
        errorBlock.addClass('popup__error--active')
    }
}

function tournamentDataSet(form) {
    'use strict'

    const googleCaptcha = form.find('.google-recaptcha')

    grecaptcha.ready(function() {
        grecaptcha.execute('6LegL8QcAAAAADO1TgGfQmdIepdvxi1pzP-JQa4D', {action: 'submit'}).then(function(token) {

            googleCaptcha.val(token);

            getDataFromAjax(form.attr('action'), 'POST', new FormData(form[0]))
                .then(res => {
                    // hidePreloader();
                    tournamentDataAnswer(form, res);
                })
        });
    });
}

function tournamentDataAnswer(form, res) {
    'use strict'

    const successfulBlock = form.parents('.popup').find('.popup__successful');
    const errorBlock = form.parents('.popup').find('.popup__error');

    if (res === 'successful') {
        form.addClass('form--hidden');
        successfulBlock.addClass('popup__successful--active');
    } else {
        form.addClass('form--hidden');
        errorBlock.addClass('popup__error--active');
    }
}

function paymentSet(form) {
    'use strict'

    const googleCaptcha = form.find('.google-recaptcha')

    grecaptcha.ready(function() {
        grecaptcha.execute('6LegL8QcAAAAADO1TgGfQmdIepdvxi1pzP-JQa4D', {action: 'submit'}).then(function(token) {

            googleCaptcha.val(token);

            getDataFromAjax(form.attr('action'), 'POST', new FormData(form[0]))
                .then(res => {
                    // hidePreloader();
                    paymentAnswer(form, res);
                })
        });
    });
}

function paymentAnswer(form, res) {
    'use strict'

    console.log(222, res)
}
